import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const PagerDutyIncidentsUpdateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}PagerDutyIncidents/GetPagerDutyIncidentsLastUpdate`
});

export const PagerDutyIncidentsAckUpdateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}PagerDutyIncidents/GetPagerDutyIncidentsAckLastUpdate`
});

export const PagerDutyIncidentsTableRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}PagerDutyIncidents/GetPagerDutyIncidentsTable`
});

export const DownloadPagerDutyIncidentsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}PagerDutyIncidents/DownloadPagerDutyIncidents`
});

export const DownloadCurrentWeekIncidentsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}PagerDutyIncidents/DownloadCurrentWeekIncidents`
});

export const GetDropdownsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}PagerDutyIncidents/GetDropdowns`
});

export const GetAllDropdownsRequest = (incidentId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}PagerDutyIncidents/GetAllDropdowns`,
	params: { incidentId }
});

export const CreateIncidentRequest = (incidentForm) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}PagerDutyIncidents/CreateIncident`,
	data: incidentForm
});

export const EditIncidentRequest = (incidentForm) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}PagerDutyIncidents/EditIncident`,
	data: incidentForm
});

export const DeleteIncidentRequest = (id) => AxiosRequest({
	method: 'DELETE',
	url: `${config.API_URL}PagerDutyIncidents/DeleteIncident`,
	params: { id }
});

export const GetIncidentRequest = (incidentId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}PagerDutyIncidents/GetIncident`,
	params: { incidentId }
});
